import moment from 'moment';

/* ======================================== */
/* clientImages */


import logoPath from '../../public/img/logo.png';
import logo2Path from '../../public/img/logo2.png';
import logoIconPath from '../../public/img/logoIcon.png';
import logoIconDarkPath from '../../public/img/logoIconDark.png';

import projectTile_1 from '../assets/images/project/projectTile_1.jpg';
import projectTile_2 from '../assets/images/project/projectTile_2.jpg';
import projectTile_3 from '../assets/images/project/projectTile_3.jpg';
import projectTile_4 from '../assets/images/project/projectTile_4.jpg';
import projectTile_5 from '../assets/images/project/projectTile_5.jpg';
import projectTile_6 from '../assets/images/project/projectTile_6.jpg';
import projectTile_7 from '../assets/images/project/projectTile_7.jpg';
import projectTile_8 from '../assets/images/project/projectTile_8.jpg';
/* ======================================== */

/* ======================================== */
        /* profile images */

import avatar_1 from '../assets/images/users/avatar_1.jpg';
import avatar_2 from '../assets/images/users/avatar_2.jpg';
import avatar_3 from '../assets/images/users/avatar_3.jpg';
import avatar_4 from '../assets/images/users/avatar_4.jpg';
import avatar_5 from '../assets/images/users/avatar_5.jpg';
import avatar_6 from '../assets/images/users/avatar_6.jpg';
import avatar_7 from '../assets/images/users/avatar_7.jpg';
import avatar_8 from '../assets/images/users/avatar_8.jpg';
import avatar_9 from '../assets/images/users/avatar_9.jpg';
import avatar_10 from '../assets/images/users/avatar_10.jpg';
import avatar_11 from '../assets/images/users/avatar_11.jpg';
import avatar_12 from '../assets/images/users/avatar_12.jpg';
import avatar_13 from '../assets/images/users/avatar_13.jpg';
import avatar_14 from '../assets/images/users/avatar_14.jpg';
import avatar_15 from '../assets/images/users/avatar_15.jpg';
import avatar_16 from '../assets/images/users/avatar_16.jpg';
import avatar_17 from '../assets/images/users/avatar_17.jpg';
import avatar_18 from '../assets/images/users/avatar_18.jpg';
import avatar_19 from '../assets/images/users/avatar_19.jpg';
import avatar_20 from '../assets/images/users/avatar_20.jpg';
import avatar_21 from '../assets/images/users/avatar_21.jpg';
import avatar_22 from '../assets/images/users/avatar_22.jpg';
import avatar_23 from '../assets/images/users/avatar_23.jpg';
import avatar_24 from '../assets/images/users/avatar_24.jpg';

/* ======================================== */

/* ======================================== */
        /* products images */

import img242874 from '../assets/images/boutique/242874.png';
import img242949 from '../assets/images/boutique/242949.png';
import img242952 from '../assets/images/boutique/242952.png';
import img243087 from '../assets/images/boutique/243087.png';
import img243090 from '../assets/images/boutique/243090.png';
import img243093 from '../assets/images/boutique/243093.png';
import img248293 from '../assets/images/boutique/248293.png';
import img264280 from '../assets/images/boutique/264280.png';
import img264283 from '../assets/images/boutique/264283.png';
import img264300 from '../assets/images/boutique/264300.png';
import img264306 from '../assets/images/boutique/264306.png';
import img264741 from '../assets/images/boutique/264741.png';
import img264743 from '../assets/images/boutique/264743.png';
import img264746 from '../assets/images/boutique/264746.png';
import img264749 from '../assets/images/boutique/264749.png';
import img3005_321_1600 from '../assets/images/boutique/3005-321-1600.png';
import img3007_321_1600 from '../assets/images/boutique/3007-321-1600.png';
import img3020_321_0900 from '../assets/images/boutique/3020-321-0900.png';
import img3022_321_1600 from '../assets/images/boutique/3022-321-1600.png';
import img3024_321_0900 from '../assets/images/boutique/3024-321-0900.png';
import img3026_321_1600 from '../assets/images/boutique/3026-321-1600.png';
import img3101_326_0900 from '../assets/images/boutique/3101-326-0900.png';
import img3118_321_1800 from '../assets/images/boutique/3118-321-1800.png';
import img350812 from '../assets/images/boutique/350812.png';
import img350813 from '../assets/images/boutique/350813.png';
import img350814 from '../assets/images/boutique/350814.png';
import img350815 from '../assets/images/boutique/350815.png';
import img350816 from '../assets/images/boutique/350816.png';
import img350817 from '../assets/images/boutique/350817.png';
import img350821 from '../assets/images/boutique/350821.png';
import img350825 from '../assets/images/boutique/350825.png';
import img350826 from '../assets/images/boutique/350826.png';
import img350870 from '../assets/images/boutique/350870.png';
import img350894 from '../assets/images/boutique/350894.png';
import img350895 from '../assets/images/boutique/350895.png';
import img350896 from '../assets/images/boutique/350896.png';
import imgBET60P_F from '../assets/images/boutique/BET60P-F.png';
import imgCP100E from '../assets/images/boutique/CP100E.png';
import imgCroix from '../assets/images/boutique/croix.png';
import imgEmpalcement from '../assets/images/boutique/empalcement.gif';
import imgEmplacement from '../assets/images/boutique/Emplacement.png';
import imgEmplacement_rouge from '../assets/images/boutique/Emplacement_rouge.png';
import imgFermer from '../assets/images/boutique/fermer.png';
import imgLEG_406278 from '../assets/images/boutique/LEG-406278.png';
import imgLEG_406298 from '../assets/images/boutique/LEG-406298.png';
import imgLEG_406879 from '../assets/images/boutique/LEG-406879.png';
import imgLEG_406881 from '../assets/images/boutique/LEG-406881.png';
import imgLEG_406883 from '../assets/images/boutique/LEG-406883.png';
import imgLEG_406901 from '../assets/images/boutique/LEG-406901.png';
import imgLEG_406904 from '../assets/images/boutique/LEG-406904.png';
import imgLEG_406919 from '../assets/images/boutique/LEG-406919.png';
import imgLEG_406922 from '../assets/images/boutique/LEG-406922.png';
import imgLEG_407780 from '../assets/images/boutique/LEG-407780.png';
import imgLEG_407904 from '../assets/images/boutique/LEG-407904.png';
import imgLEG_411505 from '../assets/images/boutique/LEG-411505.png';
import imgLEG_411506 from '../assets/images/boutique/LEG-411506.png';
import imgLEG_411632 from '../assets/images/boutique/LEG-411632.png';
import imgLEG_411633 from '../assets/images/boutique/LEG-411633.png';
import imgLEG_411652 from '../assets/images/boutique/LEG-411652.png';
import imgLEG_411653 from '../assets/images/boutique/LEG-411653.png';
import imgLEG_411661 from '../assets/images/boutique/LEG-411661.png';
import imgLEG_411662 from '../assets/images/boutique/LEG-411662.png';
import imgSSL_G220A from '../assets/images/boutique/SSL-G220A.png';
import imgVide from '../assets/images/boutique/Vide.png';
import transparent from "../assets/images/transparent.png";

/* ======================================== */
export const logo = logoPath;
export const logo2 = logo2Path;
export const logoIcon = logoIconPath;
export const logoIconDark = logoIconDarkPath;


export const projectTiles = [
  {
      id: 1,
      lib: "projectTile_1",
      path: projectTile_1,
  },
  {
      id: 2,
      lib: "projectTile_2",
      path: projectTile_2,
  },
  {
      id: 3,
      lib: "projectTile_3",
      path: projectTile_3,
  },
  {
      id: 4,
      lib: "projectTile_4",
      path: projectTile_4,
  },
  {
      id: 5,
      lib: "projectTile_5",
      path: projectTile_5,
  },
  {
      id: 6,
      lib: "projectTile_6",
      path: projectTile_6,
  },
  {
      id: 7,
      lib: "projectTile_7",
      path: projectTile_7,
  },
  {
      id: 8,
      lib: "projectTile_8",
      path: projectTile_8,
  },
]

export const avatarImages = [
  {
    id: 1,
    lib: "avatar_1",
    path: avatar_1,
  },
  {
    id: 2,
    lib: "avatar_2",
    path: avatar_2,
  },
  {
    id: 3,
    lib: "avatar_3",
    path: avatar_3,
  },
  {
    id: 4,
    lib: "avatar_4",
    path: avatar_4,
  },
  {
    id: 5,
    lib: "avatar_5",
    path: avatar_5,
  },
  {
    id: 6,
    lib: "avatar_6",
    path: avatar_6,
  },
  {
    id: 7,
    lib: "avatar_7",
    path: avatar_7,
  },
  {
    id: 8,
    lib: "avatar_8",
    path: avatar_8,
  },
  {
    id: 9,
    lib: "avatar_9",
    path: avatar_9,
  },
  {
    id: 10,
    lib: "avatar_10",
    path: avatar_10,
  },
  {
    id: 11,
    lib: "avatar_11",
    path: avatar_11,
  },
  {
    id: 12,
    lib: "avatar_12",
    path: avatar_12,
  },
  {
    id: 13,
    lib: "avatar_13",
    path: avatar_13,
  },
  {
    id: 14,
    lib: "avatar_14",
    path: avatar_14,
  },
  {
    id: 15,
    lib: "avatar_15",
    path: avatar_15,
  },
  {
    id: 16,
    lib: "avatar_16",
    path: avatar_16,
  },
  {
    id: 17,
    lib: "avatar_17",
    path: avatar_17,
  },
  {
    id: 18,
    lib: "avatar_18",
    path: avatar_18,
  },
  {
    id: 19,
    lib: "avatar_19",
    path: avatar_19,
  },
  {
    id: 20,
    lib: "avatar_20",
    path: avatar_20,
  },
  {
    id: 21,
    lib: "avatar_21",
    path: avatar_21,
  },
  {
    id: 22,
    lib: "avatar_22",
    path: avatar_22,
  },
  {
    id: 23,
    lib: "avatar_23",
    path: avatar_23,
  },
  {
    id: 24,
    lib: "avatar_24",
    path: avatar_24,
  },
]


export const products = [
  {
    id: 24,
    lib: "350812",
    img: img350812,
    type: "line",
    slots: 0
  },
  {
    id: 1,
    lib: "242874",
    img: img242874,
    type: "element"
  },
  {
    id: 2,
    lib: "242949",
    img: img242949,
    type: "element"
  },
  {
    id: 3,
    lib: "242952",
    img: img242952,
    type: "element"
  },
  {
    id: 4,
    lib: "243087",
    img: img243087,
    type: "element"
  },
  {
    id: 5,
    lib: "243090",
    img: img243090,
    type: "element"
  },
  {
    id: 6,
    lib: "243093",
    img: img243093,
    type: "element"
  },
  {
    id: 7,
    lib: "248293",
    img: img248293,
    type: "element"
  },
  {
    id: 8,
    lib: "264280",
    img: img264280,
    type: "element"
  },
  {
    id: 9,
    lib: "264283",
    img: img264283,
    type: "element"
  },
  {
    id: 10,
    lib: "264300",
    img: img264300,
    type: "element"
  },
  {
    id: 11,
    lib: "264306",
    img: img264306,
    type: "element"
  },
  {
    id: 12,
    lib: "264741",
    img: img264741,
    type: "element"
  },
  {
    id: 13,
    lib: "264743",
    img: img264743,
    type: "element"
  },
  {
    id: 14,
    lib: "264746",
    img: img264746,
    type: "element"
  },
  {
    id: 15,
    lib: "264749",
    img: img264749,
    type: "element"
  },
  {
    id: 16,
    lib: "3005-321-1600",
    img: img3005_321_1600,
    type: "element"
  },
  {
    id: 17,
    lib: "3007-321-1600",
    img: img3007_321_1600,
    type: "element"
  },
  {
    id: 18,
    lib: "3020-321-0900",
    img: img3020_321_0900,
    type: "element"
  },
  {
    id: 19,
    lib: "3022-321-1600",
    img: img3022_321_1600,
    type: "element"
  },
  {
    id: 20,
    lib: "3024-321-0900",
    img: img3024_321_0900,
    type: "element"
  },
  {
    id: 21,
    lib: "3026-321-1600",
    img: img3026_321_1600,
    type: "element"
  },
  {
    id: 22,
    lib: "3101-326-0900",
    img: img3101_326_0900,
    type: "element"
  },
  {
    id: 23,
    lib: "3118-321-1800",
    img: img3118_321_1800,
    type: "element"
  },
  {
    id: 25,
    lib: "350813",
    img: img350813,
    type: "line",
    slots: 2
  },
  {
    id: 26,
    lib: "350814",
    img: img350814,
    type: "line",
    slots: 3
  },
  {
    id: 27,
    lib: "350815",
    img: img350815,
    type: "line",
    slots: 4
  },
  {
    id: 28,
    lib: "350816",
    img: img350816,
    type: "line",
    slots: 5
  },
  {
    id: 29,
    lib: "350817",
    img: img350817,
    type: "line",
    slots: 3
  },
  {
    id: 30,
    lib: "350821",
    img: img350821,
    type: "line",
    slots: 0
  },
  {
    id: 31,
    lib: "350825",
    img: img350825,
    type: "element"
  },
  {
    id: 32,
    lib: "350826",
    img: img350826,
    type: "line",
    slots: 3
  },
  {
    id: 33,
    lib: "350870",
    img: img350870,
    type: "element"
  },
  {
    id: 34,
    lib: "350894",
    img: img350894,
    type: "element"
  },
  {
    id: 35,
    lib: "350895",
    img: img350895,
    type: "element"
  },
  {
    id: 36,
    lib: "350896",
    img: img350896,
    type: "element"
  },
  {
    id: 37,
    lib: "BET60P-F",
    img: imgBET60P_F,
    type: "element"
  },
  {
    id: 38,
    lib: "CP100E",
    img: imgCP100E,
    type: "element"
  },
  {
    id: 39,
    lib: "croix",
    img: imgCroix,
    type: "element"
  },
  {
    id: 40,
    lib: "empalcement",
    img: imgEmpalcement,
    type: "element"
  },
  {
    id: 41,
    lib: "Emplacement",
    img: imgEmplacement,
    type: "element"
  },
  {
    id: 42,
    lib: "Emplacement_rouge",
    img: imgEmplacement_rouge,
    type: "element"
  },
  {
    id: 43,
    lib: "fermer",
    img: imgFermer,
    type: "element"
  },
  {
    id: 44,
    lib: "LEG-406278",
    img: imgLEG_406278,
    type: "element"
  },
  {
    id: 45,
    lib: "LEG-406298",
    img: imgLEG_406298,
    type: "element"
  },
  {
    id: 46,
    lib: "LEG-406879",
    img: imgLEG_406879,
    type: "element"
  },
  {
    id: 47,
    lib: "LEG-406881",
    img: imgLEG_406881,
    type: "element"
  },
  {
    id: 48,
    lib: "LEG-406883",
    img: imgLEG_406883,
    type: "element"
  },
  {
    id: 49,
    lib: "LEG-406901",
    img: imgLEG_406901,
    type: "element"
  },
  {
    id: 50,
    lib: "LEG-406904",
    img: imgLEG_406904,
    type: "element"
  },
  {
    id: 51,
    lib: "LEG-406919",
    img: imgLEG_406919,
    type: "element"
  },
  {
    id: 52,
    lib: "LEG-406922",
    img: imgLEG_406922,
    type: "element"
  },
  {
    id: 53,
    lib: "LEG-407780",
    img: imgLEG_407780,
    type: "element"
  },
  {
    id: 54,
    lib: "LEG-407904",
    img: imgLEG_407904,
    type: "element"
  },
  {
    id: 55,
    lib: "LEG-411505",
    img: imgLEG_411505,
    type: "element"
  },
  {
    id: 56,
    lib: "LEG-411506",
    img: imgLEG_411506,
    type: "element"
  },
  {
    id: 57,
    lib: "LEG-411632",
    img: imgLEG_411632,
    type: "element"
  },
  {
    id: 58,
    lib: "LEG-411633",
    img: imgLEG_411633,
    type: "element"
  },
  {
    id: 59,
    lib: "LEG-411652",
    img: imgLEG_411652,
    type: "element"
  },
  {
    id: 60,
    lib: "LEG-411653",
    img: imgLEG_411653,
    type: "element"
  },
  {
    id: 61,
    lib: "LEG-411661",
    img: imgLEG_411661,
    type: "element"
  },
  {
    id: 62,
    lib: "LEG-411662",
    img: imgLEG_411662,
    type: "element"
  },
  {
    id: 63,
    lib: "SSL-G220A",
    img: imgSSL_G220A,
    type: "element"
  },
  {
    id: 64,
    lib: "Vide",
    img: imgVide,
    type: "element"
  }
];

export const transparentImage = transparent;

export const intensity = [
    '40A', 
    '63A'
];

export const protectionIndex = [
    'IP44',
];

export const chartColorsPallette = [
  "#FF9800", // Lighter orange
  "#2196F3", // Lighter blue
  "#9C27B0", // Lighter purple
  "#F44336", // Lighter red
  "#00BCD4", // Lighter teal
  "#673AB7", // Lighter indigo
  "#8BC34A", // Lighter olive green
  "#03A9F4", // Lighter ocean blue
  "#E91E63", // Lighter magenta
  "#3F51B5", // Lighter navy blue
  "#4CAF50", // Lighter green
  "#9E9E9E", // Lighter gray
  "#795548", // Lighter brown
  "#009688", // Lighter teal
  "#A1887F", // Lighter coffee brown
  "#757575", // Lighter charcoal
  "#607D8B", // Lighter blue gray
  "#78909C"  // Lighter slate
]

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const discountsByActivity = [
  { id: 'DISTRIBUTORS', label: 'DISTRIBUTORS', discountPercentage: 60 },
  { id: 'ADAPTED_COMPANY', label: 'ADAPTED_COMPANY', discountPercentage: 30 },
  { id: 'OTHERS', label: 'OTHERS', discountPercentage: 30 },
  { id: 'EVENT', label: 'EVENT', discountPercentage: 55 },
  { id: 'MANUFACTURER', label: 'MANUFACTURER', discountPercentage: 55 },
  { id: 'ENGINEERING', label: 'ENGINEERING', discountPercentage: 45 },
  { id: 'NATIONAL_INSTALLER', label: 'NATIONAL_INSTALLER', discountPercentage: 60 },
  { id: 'REGIONAL_INSTALLER', label: 'REGIONAL_INSTALLER', discountPercentage: 55 },
  { id: 'LOCAL_INSTALLER', label: 'LOCAL_INSTALLER', discountPercentage: 50 },
  { id: 'PANEL_BUILDER', label: 'PANEL_BUILDER', discountPercentage: 55 }
];


export default {
  // array
  avatarImages, 
  projectTiles,
  products,
  intensity,
  protectionIndex,
  chartColorsPallette,
  months,
  discountsByActivity,

  // images
  logo,
  logo2,
  logoIcon,
  logoIconDark,
  transparentImage

};
